module.exports = __webpack_public_path__ + "media/images/checked-checkbox-72b0facc6f3f9d409c0ed98cd2ad9e1b.svg";